<template>
  <div>
    <back-button route='/Facturen'>Alle facturen</back-button>

    <div class="md-layout md-gutter md-alignment-top-left">

      <prop-card class="md-layout-item" :data="itemVm" :header="item != null ? item.No : ''" />

      <md-card class="md-layout-item">
        <md-card-content>
          <md-table v-if="item != null && item.Lines.length > 0" v-model="item.Lines">
            <md-table-toolbar>
              <h1 class="md-title">Orderregels</h1>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Art. nr.">{{ item.No }}</md-table-cell>
              <md-table-cell md-label="Omschrijving">{{ item.Description }}</md-table-cell>
              <md-table-cell md-label="Aantal">{{ item.Quantity }}</md-table-cell>
              <md-table-cell md-label="Eenheidscode">{{ item.Unit_of_Measure_Code }}</md-table-cell>
              <md-table-cell v-if="showSUOMText" md-label="Aantal per eenheid">{{ item.wSalesUOMText }}</md-table-cell>
              <md-table-cell md-label="Eenheidsprijs">{{ Formatr.eur(item.Unit_Price) }}</md-table-cell>
              <md-table-cell md-label="Bedrag ex. BTW">{{ Formatr.eur(item.Line_Amount) }}</md-table-cell>
              <md-table-cell md-label="BTW %">{{ item.VAT_Percent }}</md-table-cell>
            </md-table-row>
          </md-table>

          <prop-card class="md-layout-item" :data="totalsVm" />

        </md-card-content>
      </md-card>
      <download-pdf class="md-layout-item" :downloading="downloading" @click="download" />
    </div>
  </div>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import PC from '@/components/PropCard';
  import BB from '@/components/BackButton';
  import DP from '@/components/DownloadPdf';
  import Format from '@/format';

  export default {
    name: 'Factuur',
    props: ['id'],
    data: () => ({
      item: null,
      downloading: false,
      Formatr: Format,
      showSUOMText: false,
    }),
    created: function() {
////////////////////////////
      this.showSUOMText = true;
////////////////
      this.load();
    },
    computed: {
      itemVm: function () {
        if (this.item !== null) {
          var obj = {
            'Nr.': this.item.No
          };
          var isVerzamelFactuur = this.item.Order_No === null || this.item.Order_No.length === 0;
          obj['Factuuradres'] = `${this.item.Bill_to_Name}\n${this.item.Bill_to_Address}\n${this.item.Bill_to_Post_Code}, ${this.item.Bill_to_City}`;
          if (!isVerzamelFactuur) { // Verzendadres niet weergeven op 'verzamelfactuur'
            const verz = `${this.item.Ship_to_Name}\n${this.item.Ship_to_Address}\n${this.item.Ship_to_Post_Code}, ${this.item.Ship_to_City}`;
            if (verz != obj['Factuuradres']) {
              obj['Verzendadres'] = verz;
            }
          }

          obj['Boekingsdatum'] = Format.date(this.item.Posting_Date);

/////////////////////////////////
          if (this.item.Due_Date) { obj['Vervaldatum'] = Format.date(this.item.Due_Date); }
////////////////////
          if (this.item.Order_No) { obj['Ordernummer'] = this.item.Order_No; }
/////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          if (this.item.External_Document_No) { obj['Extern documentnr.'] = this.item.External_Document_No; }
          return obj;
        } else {
          return null;
        }
      },
      totalsVm: function () {
        if (this.item !== null) {
        var obj = {};
          if (this.item.Invoice_Discount_Amount != 0) {
            obj["Incasso korting"] = Format.eur(-1 * this.item.Invoice_Discount_Amount); /* Display positive discount as negative number */
          }
          obj["Totaal ex. BTW"] = Format.eur(this.item.Amount);
          obj["BTW"] = Format.eur(this.item.Amount_Including_VAT - this.item.Amount);
          obj["Totaal inc. BTW"] = Format.eur(this.item.Amount_Including_VAT);
          return obj;
        } else {
          return null;
        }
      }
    },
    methods: {
      load() {
        Api.Get(`/odata/PostedSalesInvoice('${this.id}')?$expand=Lines`, ['Due_Date', 'Posting_Date'])
          .then(r => {
            r.Lines = r.Lines.map(i => i.No !== '' ? i : { Description: i.Description });
            this.item = r;
          })
          .catch(Events.RaiseExceptionOccurred);
      },
      download() {
        this.downloading = true;
        Api.DownloadFile(`/Report/Invoice/${this.id}`, `Factuur_${this.id}.pdf`)
          .then(() => { this.downloading = false; })
          .catch(e => {
            this.downloading = false;
            Events.RaiseExceptionOccurred(e);
          });
      }
    },
    components: {
      'prop-card': PC,
      'back-button': BB,
      'download-pdf': DP
    }
  };
</script>

<style scoped>
  td {
    padding: 4pt;
  }
  .tdMain {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Factuur.vue